import switchFunc from 'lib/function/switchFunc'

import { SvgIconProps } from 'components/Luxkit/SvgIcon'

import LineArrowsCompareHorizontalIcon from 'components/Luxkit/Icons/line/LineArrowsCompareHorizontalIcon'
import LineAtIcon from 'components/Luxkit/Icons/line/LineAtIcon'
import LineBookmarkFullIcon from 'components/Luxkit/Icons/line/LineBookmarkFullIcon'
import LineCalendarCheckIcon from 'components/Luxkit/Icons/line/LineCalendarCheckIcon'
import LineCalendarPlusIcon from 'components/Luxkit/Icons/line/LineCalendarPlusIcon'
import LineCarIcon from 'components/Luxkit/Icons/line/LineCarIcon'
import LineChatBubbleUserIcon from 'components/Luxkit/Icons/line/LineChatBubbleUserIcon'
import LineCheckIcon from 'components/Luxkit/Icons/line/LineCheckIcon'
import LineClockNineIcon from 'components/Luxkit/Icons/line/LineClockNineIcon'
import LineCoffeeIcon from 'components/Luxkit/Icons/line/LineCoffeeIcon'
import LineCommentAltIcon from 'components/Luxkit/Icons/line/LineCommentAltIcon'
import LineCommentMessageIcon from 'components/Luxkit/Icons/line/LineCommentMessageIcon'
import LineCommentsIcon from 'components/Luxkit/Icons/line/LineCommentsIcon'
import LineCompassIcon from 'components/Luxkit/Icons/line/LineCompassIcon'
import LineCornerDownRightAltIcon from 'components/Luxkit/Icons/line/LineCornerDownRightAltIcon'
import LineDocumentInfoIcon from 'components/Luxkit/Icons/line/LineDocumentInfoIcon'
import LineDollarSignIcon from 'components/Luxkit/Icons/line/LineDollarSignIcon'
import LineEnvelopeAltIcon from 'components/Luxkit/Icons/line/LineEnvelopeAltIcon'
import LineEnvelopeCheckIcon from 'components/Luxkit/Icons/line/LineEnvelopeCheckIcon'
import LineFastMailIcon from 'components/Luxkit/Icons/line/LineFastMailIcon'
import LineFlightCreditIcon from 'components/Luxkit/Icons/line/LineFlightCreditIcon'
import LineKeySkeletonIcon from 'components/Luxkit/Icons/line/LineKeySkeletonIcon'
import LineListOlAltIcon from 'components/Luxkit/Icons/line/LineListOlAltIcon'
import LineMobileAndroidIcon from 'components/Luxkit/Icons/line/LineMobileAndroidIcon'
import LineNotesIcon from 'components/Luxkit/Icons/line/LineNotesIcon'
import LinePhoneAltIcon from 'components/Luxkit/Icons/line/LinePhoneAltIcon'
import LinePlusIcon from 'components/Luxkit/Icons/line/LinePlusIcon'
import LineScheduleIcon from 'components/Luxkit/Icons/line/LineScheduleIcon'
import LineSearchPlusIcon from 'components/Luxkit/Icons/line/LineSearchPlusIcon'
import LineStarIcon from 'components/Luxkit/Icons/line/LineStarIcon'
import LineTimesCircleIcon from 'components/Luxkit/Icons/line/LineTimesCircleIcon'
import LineUserCheckIcon from 'components/Luxkit/Icons/line/LineUserCheckIcon'
import LineUserCircleIcon from 'components/Luxkit/Icons/line/LineUserCircleIcon'
import LineUserExclamationIcon from 'components/Luxkit/Icons/line/LineUserExclamationIcon'
import LineUserIcon from 'components/Luxkit/Icons/line/LineUserIcon'
import LineUserPlusIcon from 'components/Luxkit/Icons/line/LineUserPlusIcon'
import LinePhoneIcon from 'components/Luxkit/Icons/line/LinePhoneIcon'

// These are the icons that are present in the LESA Figma file.
// Not all the associated chat categories exist yet.
const LESA_ICONS: Record<
  string,
  React.FunctionComponent<SvgIconProps>
> = {
  arrowsCompareHorizontal: LineArrowsCompareHorizontalIcon,
  at: LineAtIcon,
  bookmarkFull: LineBookmarkFullIcon,
  calendarCheck: LineCalendarCheckIcon,
  calendarPlus: LineCalendarPlusIcon,
  car: LineCarIcon,
  chatBubbleUser: LineChatBubbleUserIcon,
  check: LineCheckIcon,
  clockNine: LineClockNineIcon,
  coffee: LineCoffeeIcon,
  commentAlt: LineCommentAltIcon,
  commentMessage: LineCommentMessageIcon,
  comments: LineCommentsIcon,
  compass: LineCompassIcon,
  cornerDownRightAlt: LineCornerDownRightAltIcon,
  documentInfo: LineDocumentInfoIcon,
  dollarSign: LineDollarSignIcon,
  envelopeAlt: LineEnvelopeAltIcon,
  envelopeCheck: LineEnvelopeCheckIcon,
  fastMail: LineFastMailIcon,
  flightCredit: LineFlightCreditIcon,
  keySkeleton: LineKeySkeletonIcon,
  listOlAlt: LineListOlAltIcon,
  mobileAndroid: LineMobileAndroidIcon,
  notes: LineNotesIcon,
  phoneAlt: LinePhoneAltIcon,
  plus: LinePlusIcon,
  schedule: LineScheduleIcon,
  searchPlus: LineSearchPlusIcon,
  star: LineStarIcon,
  timesCircle: LineTimesCircleIcon,
  user: LineUserIcon,
  userCheck: LineUserCheckIcon,
  userCircle: LineUserCircleIcon,
  userExclamation: LineUserExclamationIcon,
  userPlus: LineUserPlusIcon,
  luxPlus: LinePhoneIcon,
}

// Map chat category keys to customer portal icons.
// only some chat categories have been assigned icons so far.
const MESSAGE_CATEGORY_MAP: Record<App.ChatContentCategories, string | undefined> = {
  airportTransfers: 'car',
  airportTransfersAdd: 'plus',
  airportTransfersArrange: 'clockNine',
  cancel: 'timesCircle',
  chatAgent: 'chatBubbleUser',
  chatNew: 'plus',
  chatLesa: 'comments',
  chatRecent: 'commentAlt',
  confirm: 'check',
  frequentFlyer: 'flightCredit',
  order: 'calendarCheck',
  orderCancel: 'timesCircle',
  orderAddDates: 'calendarPlus',
  orderChangeDates: 'schedule',
  orderChangeRoom: 'arrowsCompareHorizontal',
  orderFinePrint: 'documentInfo',
  orderInclusions: 'coffee',
  orderItemList: 'listOlAlt',
  orderList: 'calendarCheck',
  orderNew: 'searchPlus',
  orderResendConfirmation: 'envelopeCheck',
  other: 'commentMessage',
  paymentIssues: 'dollarSign',
  redirectMyEscapes: 'cornerDownRightAlt',
  requestAgentCallback: 'phoneAlt',
  userEmail: 'envelopeAlt',
  userLogIn: 'userPlus',
  userLogInIssue: 'userExclamation',
  userLogInPhone: 'mobileAndroid',
  userPasswordReset: 'keySkeleton',
  userUpdate: 'userCheck',
  userUpdateEmail: 'at',
  userUpdateName: 'userCircle',
  userUpdatePhone: 'phoneAlt',
  userUpdateSubscription: 'envelopeAlt',
  luxPlusPrioritySupport: 'luxPlus',
}
const actionSwitch = switchFunc(LESA_ICONS, undefined)

export function getActionIcon(value: string = '') {
  const key = MESSAGE_CATEGORY_MAP[value]
  if (!key) return

  return actionSwitch(key)
}
